export function promisifyJigsawCall(
  fn: (...args: any[]) => void,
  args: any[] = []
): crane.Response {
  return new Promise(resolve => {
    fn(...args, (resp: jigsaw.JigsawResponse<any>) => {
      resolve({
        ok: resp.isSuccess(),
        data: resp.data,
        status: resp.code,
      });
    });
  });
}
